import React from 'react'
import { Table } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

const HikingClassification = () => {
  const { t } = useTranslation()

  return (
    <div>
      <h2 style={{ marginBottom: '20px' }}>
        {t('POI_TYPE_CLASSIFICATION_TITLE')}
      </h2>
      <p>{t('POI_TYPE_HIKING_PAGE_CLASSIFICATION_DESCRIPTION')}</p>

      <div className="mt-5 text-center">
        <Table bordered className="rdb-table">
          <thead>
            <tr>
              <th>{t('TOTAL_POINTS')}</th>
              <th>{t('TRAIL_COLOR')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{t('UP_TO_15_EQUIVALENT_KM')}</td>
              <td>{t('GREEN')}</td>
            </tr>
            <tr>
              <td>{t('FROM_15_TO_30_EQUIVALENT_KM')}</td>
              <td>{t('BLUE')}</td>
            </tr>
            <tr>
              <td>{t('FROM_30_TO_60_EQUIVALENT_KM')}</td>
              <td>{t('RED')}</td>
            </tr>
            <tr>
              <td>{t('MORE_THAN_60_EQUIVALENT_KM')}</td>
              <td>{t('BLACK')}</td>
            </tr>
          </tbody>
        </Table>
      </div>
    </div>
  )
}

export default HikingClassification
